/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ProductSummary} from '../models/ProductSummary';
import type {UsersActiveProductsSearchRequest} from '../models/UsersActiveProductsSearchRequest';

export interface GetAvailableProducts$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAvailableProductsRequest = createAction<PayloadData<void>>('PRODUCTS__GET_AVAILABLE_PRODUCTS__REQUEST');
export const getAvailableProductsSuccess = createAction<PayloadData<Array<ProductSummary>>>('PRODUCTS__GET_AVAILABLE_PRODUCTS__SUCCESS');
export const getAvailableProductsFailure = createAction<PayloadData<Error, void, true>>('PRODUCTS__GET_AVAILABLE_PRODUCTS__FAILURE');

export const getAvailableProductsActions = [
    getAvailableProductsRequest,
    getAvailableProductsSuccess,
    getAvailableProductsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAvailableProducts = (config?: GetAvailableProducts$Config) => {
    return {
        CALL_API: {
            types: getAvailableProductsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/product-subscriptions/products`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface SearchUsersActiveProducts$Request {
    usersActiveProductsSearchRequest: UsersActiveProductsSearchRequest;
}

export interface SearchUsersActiveProducts$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchUsersActiveProductsRequest = createAction<PayloadData<void, SearchUsersActiveProducts$Request>>('PRODUCTS__SEARCH_USERS_ACTIVE_PRODUCTS__REQUEST');
export const searchUsersActiveProductsSuccess = createAction<PayloadData<{ [key: string]: Array<string>; }, SearchUsersActiveProducts$Request>>('PRODUCTS__SEARCH_USERS_ACTIVE_PRODUCTS__SUCCESS');
export const searchUsersActiveProductsFailure = createAction<PayloadData<Error, SearchUsersActiveProducts$Request, true>>('PRODUCTS__SEARCH_USERS_ACTIVE_PRODUCTS__FAILURE');

export const searchUsersActiveProductsActions = [
    searchUsersActiveProductsRequest,
    searchUsersActiveProductsSuccess,
    searchUsersActiveProductsFailure
] as const;

/**
 * Returns active product external keys grouped by user ID, without pagination. Users without active products, including unknown users, are omitted. Duplicate user IDs are processed once. An empty userIds list returns an empty object. Requires USER_PRODUCTS_VIEW access.
 * @param {UsersActiveProductsSearchRequest} meta.usersActiveProductsSearchRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchUsersActiveProducts = (meta: SearchUsersActiveProducts$Request, config?: SearchUsersActiveProducts$Config) => {
    return {
        CALL_API: {
            types: searchUsersActiveProductsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/active-products/search`,
            TRANSPORT_REQUEST_BODY: meta.usersActiveProductsSearchRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

